import { client } from '../client/utils'

export function BulkLmsIdFix(coursenum) {
  $.meDialog.yesno(
    'Confirm',
    'Attempt to resolve the Canvas Id all students?',
    () => {
      client
        .post(`/instructor/people.bulk_fix_lms_id/${coursenum}/`)
        .then(() => {
          window.$('#widget_container').trigger('reload_widgets')
        })
        .catch(() => {
          $.meDialog.message(
            'Error',
            'Bulk fix canvas Ids failed. Please Contact our support team at support@myeducator.com'
          )
        })
    }
  )
}
